import React from 'react';

const TaxaConversaoCambioContext = React.createContext();

export default TaxaConversaoCambioContext;
